import { Reducer } from "redux";
import { DischargeTypes, DischargeState } from "./types";

export const INITIAL_STATE_DISCHARGE: DischargeState = {
  data: null,
  loading: false,
  success: false,
  error: false,
  reasons: [],
  reasonsLoading: false
};

const reducer: Reducer<DischargeState> = (
  state = INITIAL_STATE_DISCHARGE,
  action
) => {
  switch (action.type) {
    case DischargeTypes.LOAD_REQUEST:
    case DischargeTypes.SUBMIT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
      };

    case DischargeTypes.LOAD_REASONS_REQUEST:
      return {
        ...state,
        reasonsLoading: true,
      };

    case DischargeTypes.LOAD_REASONS_SUCCESS:
      return {
        ...state,
        reasonsLoading: false,
        reasons: action.payload,
      };

    case DischargeTypes.LOAD_REASONS_FAILURE:
      return {
        ...state,
        reasonsLoading: false,
      };

    case DischargeTypes.LOAD_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
        success: true,
      };

    case DischargeTypes.SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };

    case DischargeTypes.LOAD_FAILURE:
    case DischargeTypes.SUBMIT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
      };

    default:
      return state;
  }
};

export default reducer;
